import { login, loginCode,logout, getUserInfo,getuserpermission,getermissionlist } from '@/api/user'
import { setToken, getToken, setName , getName, getBusinessId ,getEnterpriseName,setEnterpriseName, setBusinessId} from '@/libs/util'
import { encryptionSignResult} from '@/libs/tools'

export default {
  state: {
    userName: getName(),//用户名
    businessId: getBusinessId(), // 企业ID
    enterpriseName:getEnterpriseName(), //企业名
    // userId: '',
    // avatorImgPath: '',
    token: getToken(),
    hasAccessFlag:false,
    access: [], //当前企业下所有权限id集合
    permissionList:[], //当前企业下的所有权限
    userPermissionList:[],//用户权限
  },
  mutations: {
    setAvator (state, avatorPath) {
      state.avatorImgPath = avatorPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setUserName (state, name) {
      state.userName = name
      setName(name)
    },
    setBusinessId (state, id) {
        state.businessId = id;
        // setName(name)
        setBusinessId(id)
    },
    setAccess (state, access) {
      state.access = access
    },
    setToken (state, token) {
      state.token = token;
      setToken(token)
    },
    setEnterpriseName (state, name) {
      state.enterpriseName = name;
      // setName(name)
      setEnterpriseName(name)
    },
    setUserPermission(state,userPermissionList){
      state.userPermissionList = userPermissionList;
    },
    setUserPermissionIdArray(state, array){
      state.access = array;
    },
    setUserPermissionStatus (state, status) {
      state.hasAccessFlag = status
    },
    setPermissionList (state, permissionList) {
      state.permissionList = permissionList;
    },
    setAccessFlagFlag(state,flag){
      console.log(state.hasAccessFlag)
      state.hasAccessFlag = flag
    },
  },
  actions: {
    // 登录
    handleLogin ({ commit }, postData) {
      return new Promise((resolve, reject) => {
        login(postData).then(res => {
          // console.log("登录接口");
          // console.log(res)  //false or data
          if(res){
            const data = res.data;
            commit('setToken', data.token);
            commit('setEnterpriseName', data.enterprise.name);
            commit('setUserName', data.userName);
            commit('setBusinessId', data.enterprise.id);
            // commit('setAccessFlagFlag',false)
          }
          resolve(res.data);
        }).catch(err => {
          console.log("失败了");
          reject(err)
        })
      })
    },
    // 登录短信验证码
    handleLoginCode ({ commit }, postData) {
      return new Promise((resolve, reject) => {
        loginCode(postData).then(res => {
          if(res){
            const data = res.data;
            commit('setToken', data.token);
            commit('setEnterpriseName', data.enterprise.name);
            commit('setUserName', data.userName);
            commit('setBusinessId', data.enterprise.id);
          }
          resolve(res.data);
        }).catch(err => {
          console.log("失败了");
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('setToken', '')
        //   commit('setAccess', [])
        //   resolve()
        // }).catch(err => {
        //   reject(err)
        // })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        commit('setToken', '')
        commit('setAccess', [])
        commit('setUserName', '')
        commit('setBusinessId', '');
        // commit('setAccessFlagFlag',false)
        resolve()
      })
    },

    // //用户权限列表
    getuserpermission ({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          let obj = encryptionSignResult({})
          getuserpermission(obj).then(res => {
            let data = res.data;
            commit('setUserPermissionStatus', true)
            commit('setUserPermission', data);
            let dataIdArray = data.map((item)=>{
              return item.id
            })
            // console.log(dataIdArray);
            commit('setUserPermissionIdArray', dataIdArray);
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },

    //企业下全部的权限列表
    getermissionlist ({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          let obj = encryptionSignResult({})
          getermissionlist(obj).then(res => {
            // console.table(res.data)
            commit('setPermissionList', res.data);
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js